import { render, staticRenderFns } from "./routescomponents.vue?vue&type=template&id=2117e45c"
import script from "./routescomponents.vue?vue&type=script&lang=js"
export * from "./routescomponents.vue?vue&type=script&lang=js"
import style0 from "./routescomponents.vue?vue&type=style&index=0&id=2117e45c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports